import { render, staticRenderFns } from "./PushListView.vue?vue&type=template&id=b285013c"
import script from "./PushListView.vue?vue&type=script&lang=js"
export * from "./PushListView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports